import { combineReducers } from 'redux';
import adminReducer from './Admin.reducer';
import masterReducer from './Master.reducer';
import reportreducer from './Report.reducer';
import billReducer from './Billing.reducer';

const rootReducers = combineReducers({
    admin: adminReducer,
    master: masterReducer,
    report: reportreducer,
    bills:billReducer
})

export default rootReducers;